import BackgroundImage from "@/assets/images/twilio/background.jpg"

const getBackgroundImage = (): Promise<HTMLImageElement> => {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => {
      resolve(img)
    }
    img.onerror = reject
    img.src = BackgroundImage
  })
}

export { getBackgroundImage }
